import { all } from 'redux-saga/effects';
import { watchShowPageAsync } from './system/showPageSaga';

export default function* rootSaga() {
    yield all([
        watchShowPageAsync(),
    ]);
}

